/**
 * ─────────────────────────────────────────────────────────────
 * Funnel instrumentation events (InterviewLandingPage)
 * Create these in LinkedIn Campaign Manager and paste IDs here.
 * ─────────────────────────────────────────────────────────────
 */

/**
 * Fires ONCE per page load when the public contributor page (/contributors)
 * renders. This is the top-of-funnel page that sits IN FRONT of
 * /participate/<slug>, so it measures ad → page separately from ad → funnel.
 *
 * TODO: create this conversion in LinkedIn Campaign Manager and paste the ID
 * here. Until then it is 0 and trackLinkedInConversion() no-ops.
 */
export const LINKEDIN_CONV_ID_CONTRIBUTOR_PAGE_VIEWED = 0;


/**
 * Fires ONCE per page load when:
 * - Interview type has successfully loaded
 * - Step === STEP_LANDING (the TRUE landing page is visible)
 *
 * This measures: LinkedIn Ad click → landing page render success.
 */
export const LINKEDIN_CONV_ID_LANDING_VIEWED = 23695196;


/**
 * Fires when the user clicks ANY calendar reminder option:
 * - "Add to Google Calendar"
 * - "Add to Outlook"
 * - "Download calendar file (.ics)"
 *
 * Fires immediately on click (intent), not on confirmation.
 *
 * This measures: delayed intent / “do later” behavior.
 */
export const LINKEDIN_CONV_ID_REMINDER_ADDED = 23695204;


/**
 * Fires ONLY when:
 * - User selects "Yes" on the eligibility question
 * - User clicks the "Continue" button
 * - Navigation from STEP_ELIGIBILITY → STEP_OVERVIEW occurs
 *
 * Does NOT fire:
 * - When the eligibility question is merely answered
 * - When user selects "No"
 *
 * This measures: qualified users who actively pass eligibility.
 */
export const LINKEDIN_CONV_ID_ELIGIBILITY_PASSED = 23695212;


/**
 * Fires ONLY when:
 * - User clicks the primary CTA on the Overview step
 * - Navigation from STEP_OVERVIEW → STEP_ABOUT occurs
 *
 * Does NOT fire:
 * - When the overview step is merely viewed (impression)
 *
 * This measures: users who understand the interview and opt in.
 */
export const LINKEDIN_CONV_ID_OVERVIEW_CONTINUED = 23695220;


/**
 * Fires ONCE when:
 * - STEP_ABOUT ("About you" form) is first rendered
 *
 * Fires regardless of whether the form is completed.
 * Does NOT fire again if user navigates back and forth.
 *
 * This measures: mid-funnel commitment (form exposure).
 */
export const LINKEDIN_CONV_ID_ABOUT_FORM_VIEWED = 23695228;


/**
 * Fires when:
 * - User selects ANY payment method option
 *   (PayPal, Venmo, or Amazon)
 *
 * Fires immediately on selection click.
 * May fire more than once if user changes selection.
 *
 * This measures: payout friction and payment preference.
 */
export const LINKEDIN_CONV_ID_PAYMENT_METHOD_SELECTED = 23695236;


/**
 * Fires when:
 * - User clicks the "Start interview" button
 * - BEFORE form validation and BEFORE backend request
 *
 * Does NOT guarantee interview creation.
 * Compare against INTERVIEW_STARTED to detect drop-off.
 *
 * This measures: final intent to begin interview.
 */
export const LINKEDIN_CONV_ID_START_INTERVIEW_CLICKED = 23695244;


/**
 * Fires ONLY after the backend successfully creates an interview
 * (i.e. POST /start-interview returns interview_id).
 *
 * This represents a REAL interview start, not just intent.
 */
export const LINKEDIN_CONV_ID_INTERVIEW_STARTED = 23301068;


/**
 * Fires when the interview is fully completed and uploaded.
 * This is triggered in InterviewPage.js (not in the landing page).
 */
export const LINKEDIN_CONV_ID_INTERVIEW_COMPLETED = 23301076;


